import {action, computed, observable, makeObservable} from 'mobx';

import {userStore} from './user.store';
import {accordionStore} from './accordion.store';
import {headerStore} from './header.store';
import {uploadStore} from './upload.store';
import {NewMasterStore} from './new-master.store';
import {utilsService} from '../services/utils.service';
import { apiService } from '../services/api.service';
import _ from 'lodash';
const newMasterStore = NewMasterStore.create();

class MasterStore {

  constructor() {
    makeObservable(this);
    this.userStore = userStore;
    this.accordionStore = accordionStore;
    this.headerStore = headerStore;
    this.uploadStore = uploadStore;
    this.newMasterStore = newMasterStore;
  }

  getUser() {
    return this.userStore.user;
  }

  // ACTIONS
  @action initSite() {
    //check for pre-existing tokens as URL parameters
    const bearerToken = utilsService.getUrlParameter('token');
    // const bearerToken = 'eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIyMDA1Rk5QU0UxQGF0dC5jb20iLCJpc3MiOiJodHRwczovL2FwaS5maXJzdG5ldC5hdHQuY29tIiwiYXVkIjoiZmlyc3RuZXRfdXNlciIsImp0aSI6IjIwMDVGTlBTRTFAYXR0LmNvbTE2MDUxMDgxODgzMjgiLCJpYXQiOjE2MDUxMDgxODgsImV4cCI6MTYwNTEwODc4OCwiaWQiOiIxODAwMDAwMDAyMzMzNzciLCJ1c2VybmFtZSI6IjIwMDVGTlBTRTFAYXR0LmNvbSIsImZpcnN0TmFtZSI6ImZpcnN0bmV0IiwibGFzdE5hbWUiOiJwc2VvbmUiLCJyZXZlcmlmeSI6IlkiLCJlbWFpbCI6ImthemkuYW1pbkBpYm0uY29tIiwicm9sZXMiOlsiR19GTiIsIkdfRk5fQURNIiwiR19GTl9ERVYiXSwiYXV0aG9yaXphdGlvbnMiOlt7InBzZUlkIjoiRk4yMDA1IiwicHNlVXNlclJvbGVzIjpbIkdfRk4iLCJHX0ZOX0FETSIsIkdfRk5fREVWIl0sInBzZU5hbWUiOiJGaXJzdE5ldCBGTlBJMiBUZXN0IE5BIE9yZyAwMSIsImlzUHJlbWllclVzZXIiOmZhbHNlfV0sInBzZUFwcEFkbWluIjoiTiIsInRyYWluaW5nUG9ydGFsQWRtaW4iOiJZIn0.N3pVIUpjwvcmLI2nccIpUW-g2bAFlcVjVJ_SxRmv4rM';
    const jwtToken = utilsService.getUrlParameter('id_token');

    if (bearerToken && bearerToken.length > 0) {
      this.userStore.initUserObject(bearerToken);
      this.fetchTrainingPortalData();
      //this.getSectionsIsAllowed();
    // this.getIsNewSecEmpty();
    } else {
      // Commenting to redirect to Halo B for logging in

      // get token the long way; first time logging in
      // if(this.userStore.isInAdminPerspective) {
      //   this.userStore.authenticateUserWithCsp(jwtToken).then(() => {
      //     this.fetchTrainingPortalData();
      //   })
      // } else {
        this.userStore.authenticateUserWithHalo(jwtToken).then(() => {
          this.fetchTrainingPortalData();

          //this.getSectionsIsAllowed();
         // this.getIsNewSecEmpty();
        })
      // }
    }
  }
  //function for searching content
  @action searchContent(){
    this.isSearching=true;
    this.contentItemList=[];
    console.log(this.searchQuery);
    this.searchValue=this.searchQuery;
    if(this.searchQuery==''){
      this.isSearching=false;
      this.contentItemList=this.newMasterStore.ContentItems.sortedContentList.filter(category => category.sectionTitle);
      this.isSearchClicked=false;
      return;
    }
    
    else{
      const searchWords = this.searchQuery.split(' ');
    this.contentItemListCopy=this.newMasterStore.ContentItems.sortedContentList.filter(category => category.sectionTitle && category.sectionId!=14);
    var res=0;
    
    for(let i = 0; i < this.contentItemListCopy.length; i++) {
        let tempArr=[];
        for(let k=0 ; k<searchWords.length ; k++)
        {
            for(let j=0;j<this.contentItemListCopy[i].sectionItems.length;j++)
            {
              if((this.contentItemListCopy[i].sectionItems[j].title && this.contentItemListCopy[i].sectionItems[j].title.toLowerCase().includes(searchWords[k].toLowerCase()))||(this.contentItemListCopy[i].sectionItems[j].description&& this.contentItemListCopy[i].sectionItems[j].description.toLowerCase().includes(searchWords[k].toLowerCase()))||(this.contentItemListCopy[i].sectionItems[j].keywords &&this.contentItemListCopy[i].sectionItems[j].keywords.toLowerCase().includes(searchWords[k].toLowerCase()))){
                let unique=true;
                tempArr.forEach(function(item) {
                  if (_.isEqual(item.id, this.id)) unique = false;
              },this.contentItemListCopy[i].sectionItems[j]);
              if (unique)  tempArr.push(this.contentItemListCopy[i].sectionItems[j]);

              }

            }
        }
        this.contentItemListCopy[i].sectionItems=tempArr;


        }
      
    
      // after filter count result with addtional condition
    for(let i=0;i<this.contentItemListCopy.length;i++)
    {
      if(this.newMasterStore.isInEditMode&&this.contentItemListCopy[i].sectionId!=15)
      {
          res+=this.contentItemListCopy[i].sectionItems.length;
      }
      else
      {
          if(this.contentItemListCopy[i].sectionItems.length!=0&&this.contentItemListCopy[i].sectionId!=15)
          {
            
            if(this.contentItemListCopy[i].sectionTitle ==='FirstNet Mission Control & FirstNet Mission IQ videos (New)'|| this.contentItemListCopy[i].sectionTitle==='FirstNet Mission Control & FirstNet Mission IQ user guides (New)')
            {
              
              if(this.isAdmin || this.accordionStore.isAllowed)
              {
                  res+=this.contentItemListCopy[i].sectionItems.length;
    
              }
    
            }
            else
            {
              res+=this.contentItemListCopy[i].sectionItems.length;
    
            }
          }
        }
        

    }
    
    
    this.resultCount=res;
    if(res>0)
    {
      // if result found
      this.contentItemList=this.contentItemListCopy.filter(category => category.sectionItems.length > 0 && category.sectionId!=14 )
      this.accordionStore.expandAll();
    }
    else
    {
      //if not then deafult view
        this.accordionStore.toggleEverythingIsExpanded();
        this.contentItemList=this.newMasterStore.ContentItems.sortedContentList.filter(category => category.sectionTitle);
        var isMobile = window.orientation > -1;
        if(!isMobile){
        //if not mobile then default view of started videos will be expanded
        //if the name changes then please change it here also

      if( !this.isAdmin && !this.accordionStore.isAllowed)
      {
        //console.log('admin '+this.props.store.isAdmin+' allowed '+this.accordionStore.isAllowed);
        this.accordionStore.handleSectionToggle('Getting started videos');
        //console.log('hola');
        //this.count++;
      }
      else if(  !this.isAdmin && this.accordionStore.isAllowed)
      {
          this.accordionStore.handleSectionToggle(this.getFirstElementTitle());
          //this.count++;
      }
      else if(this.isAdmin){
          this.accordionStore.handleSectionToggle(this.getFirstElementTitle());
          //this.count++;
      }
      
    }
    
    }
    

    
    console.log(JSON.stringify(this.contentItemList));

  }
  this.isSearching=false;
  this.isSearchClicked=true;
  }
  @action handleInput(val) {
		this.searchQuery = val;
	}
  @action clearSearchQuery(){
    this.searchQuery='';
  }
  @action resetSearch(){
    this.searchValue='';
    this.resultCount=-1;
    this.isSearchClicked=false;
    this.clearSearchQuery();
    this.accordionStore.toggleEverythingIsExpanded();
    this.contentItemList=this.newMasterStore.ContentItems.sortedContentList.filter(category => category.sectionTitle);
    var isMobile = window.orientation > -1;
    if(!isMobile){
      //if not mobile then default view of started videos will be expanded
      //if the name changes then please change it here also

      if( !this.isAdmin && !this.accordionStore.isAllowed)
      {
        //console.log('admin '+this.props.store.isAdmin+' allowed '+this.accordionStore.isAllowed);
        this.accordionStore.handleSectionToggle('Getting started videos');
        //console.log('hola');
        //this.count++;
      }
      else if(  !this.isAdmin && this.accordionStore.isAllowed)
      {
          this.accordionStore.handleSectionToggle(this.getFirstElementTitle());
          //this.count++;
      }
      else if(this.isAdmin){
          this.accordionStore.handleSectionToggle(this.getFirstElementTitle());
          //this.count++;
      }
      
    }
    window.scrollTo(0, 0);
  }

  @action fetchTrainingPortalData() {
    this.newMasterStore.ContentItems.fetchContentItems()
    .finally( ()=>
      {
        this.contentItemList=newMasterStore.ContentItems.sortedContentList.filter(category => category.sectionTitle);

      });

  }

  @action getSectionsIsAllowed(){
    const success = (response) => {
			this.isAllowed = response.is_allowed;
      //console.log('from master store '+this.isAllowed);
      return this.isAllowed;
		}

		const failure = () => {
			this.isAllowed=false;
		}
    apiService.getSectionsIsAllowed().then(success,failure);
  }
@action setIsAdmin(value){
  this.isAdminValue=value;
}
@action getFirstElementTitle(){
  var temp=newMasterStore.ContentItems.sortedContentList.filter(category =>category.sectionTitle);
  
  if (temp[0].sectionItems.length!=0)
    return temp[0].sectionTitle;
  else if (temp[1].sectionItems.length!=0)
    return temp[1].sectionTitle;
  else
    return temp[2].sectionTitle;
  
}

  //COMPUTEDS
  @computed get isLoggedIn() {
    return this.userStore.isAuthenticHaloUser || this.userStore.isAuthenticCspUser;
  }
  @computed get isAdmin(){
    return this.isAdminValue;
  }
  @computed get contentItemListValue(){
    return this.contentItemList;
  }

  @observable fetchStarted = false;
  @observable contentItemList = [];
  @observable contentItemListCopy = [];
  @observable categories = [];
  @observable top = {};
  @observable bottom = {};
  @observable isAllowed = false;
  @observable isAdminValue = false;
  @observable searchQuery='';
  @observable resultCount=-1;
  @observable isSearching=false;
  @observable isSearchClicked=false;
  @observable searchValue='';
  
}

export const masterStore = new MasterStore();
